import { authedApiFetch } from '../utils/Api';

const inputSignalRulesService = {
	getInputSignalRules: async (
		subscribed = false,
		sortBy = 'created_at',
		sortOrder = 'desc'
	) => {
		const response = await authedApiFetch({
			endpoint: `/input_signal_rules?subscribed=${subscribed}&sort_column=${sortBy}&sort_order=${sortOrder}`,
			method: 'GET',
		});
		return response;
	},

	createInputSignalRule: async (params) => {
		const resp = authedApiFetch({
			endpoint: `/input_signal_rules`,
			method: 'POST',
			payload: params,
		});

		return resp;
	},

	createInputSignalRulesBulk: async (rules) => {
		const response = await authedApiFetch({
			endpoint: '/input_signal_rules_bulk',
			method: 'POST',
			payload: {
				input_signal_rules: rules,
			},
		});

		return response;
	},

	testInputSignalRule: async (params) => {
		const response = await authedApiFetch({
			endpoint: '/input_signal_rules/test',
			method: 'POST',
			payload: params,
			returnResponse: true,
		});

		const body = await response.json().catch(() => ({}));

		if (!response.ok || !body.success) {
			throw new Error(body.error || 'Alert test failed. Please try again.');
		}

		return body;
	},
};

export default inputSignalRulesService;
